import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "location-selection" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Betriebsauswahl", -1)
const _hoisted_3 = ["value"]

import {ref, watch} from "vue";
import {useStore} from "vuex";
import User from "@/api/types/User";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationSelection',
  setup(__props) {

const store = useStore()

const locationId = ref<number|null>(store.state.selectedLocationId)
const user = ref<User>(store.state.configuration.user)

watch(locationId, () => store.commit('SET_LOCATION_ID', locationId.value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((locationId).value = $event))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.locations, (location) => {
        return (_openBlock(), _createElementBlock("option", {
          value: location.id,
          key: location.id
        }, _toDisplayString(`${location.name} - ${location.registrationNr}`), 9, _hoisted_3))
      }), 128))
    ], 512), [
      [_vModelSelect, locationId.value]
    ])
  ]))
}
}

})